'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _EmailPreferenceToggleContainer = require('../../../workspace/header/utils/account/email/EmailPreferenceToggleContainer');

var _EmailPreferenceToggleContainer2 = _interopRequireDefault(_EmailPreferenceToggleContainer);

var _EditableUserName = require('./editableUserName/EditableUserName');

var _EditableUserName2 = _interopRequireDefault(_EditableUserName);

var _EditableUserEmail = require('./editableUserEmail/EditableUserEmail');

var _EditableUserEmail2 = _interopRequireDefault(_EditableUserEmail);

var _accountConstants = require('../accountConstants');

require('./AccountSettingsModal.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Components


// Constants


// Styles


var mapStateToProps = function mapStateToProps(state) {
    return {
        currentUser: state.getIn(['app', 'currentUser'])
    };
};

var AccountSettingsModal = function (_React$Component) {
    _inherits(AccountSettingsModal, _React$Component);

    function AccountSettingsModal() {
        _classCallCheck(this, AccountSettingsModal);

        return _possibleConstructorReturn(this, (AccountSettingsModal.__proto__ || Object.getPrototypeOf(AccountSettingsModal)).apply(this, arguments));
    }

    _createClass(AccountSettingsModal, [{
        key: 'render',
        value: function render() {
            var currentUser = this.props.currentUser;


            return _react2.default.createElement(
                'div',
                { className: 'AccountSettingsModal' },
                _react2.default.createElement(
                    'h2',
                    null,
                    'Settings'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'user-details section' },
                    _react2.default.createElement(_EditableUserName2.default, null),
                    _react2.default.createElement(_EditableUserEmail2.default, null)
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'section' },
                    _react2.default.createElement(
                        'h3',
                        null,
                        'Email preferences'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _accountConstants.EMAIL_PREFERENCE_CHECKLIST.map(function (emailPreferenceEntry) {
                            return _react2.default.createElement(_EmailPreferenceToggleContainer2.default, {
                                key: emailPreferenceEntry.value,
                                currentUser: currentUser,
                                emailPreferenceEntry: emailPreferenceEntry });
                        })
                    )
                ),
                _react2.default.createElement('div', { className: 'section' })
            );
        }
    }]);

    return AccountSettingsModal;
}(_react2.default.Component);

AccountSettingsModal.propTypes = {
    displayName: _propTypes2.default.string,
    email: _propTypes2.default.string,
    currentUser: _propTypes2.default.object
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(AccountSettingsModal);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/settings/AccountSettingsModal.js
// module id = 2081
// module chunks = 0